import { ButtonProps, ButtonWithGAClickButton } from 'common/components';
import { useBottomOffset } from 'common/hooks/use-top-offset';
import { styled } from 'linaria/react';
import React from 'react';

type TProps = {
  btnProps: ButtonProps;
  isVisible?: boolean;
  elementBlock: string;
  label: string;
}

type StyledStickyButtonProps = {
  bottomOffset: number;
  isVisible: boolean;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const StyledStickyButton = styled.div<StyledStickyButtonProps>`
  bottom: ${({ bottomOffset, isVisible }) => isVisible ? `${20 + bottomOffset}px` : '-100%'};
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.4s ease;
  z-index: 2;
`;

export const StickyButton: React.FC<TProps> = ({
  elementBlock, btnProps, isVisible = true, label,
}) => {
  const bottomOffset = useBottomOffset();

  return (
    <StyledStickyButton isVisible={isVisible} bottomOffset={bottomOffset}>
      <ButtonWithGAClickButton
        elementBlock={elementBlock}
        elementName="sticky-panel"
        elementText={label}
        rounded
        variant="accent"
        {...btnProps}
      >
        {label}
      </ButtonWithGAClickButton>
    </StyledStickyButton>
  );
}
